<template>
  <modal ref='modal' class="upload-files-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('record.rename_file') }}</h5>
    </template>

    <template #body>
      <form @submit.prevent='renameFile($event)'>
        <div class='modal-body'>
          <label>
            {{ $t('records_list.file_name') }}
          </label>

          <input type='text' name='record[filename]' class='form-control' :value='record.name' />
        </div>

        <div class='modal-footer'>
          <input type='submit' class='btn btn-primary float-right' :value="$t('records_list.dropdown.rename')" />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'

  export default {
    components: {
      modal: _modal,
    },
    data() {
      return {
        record: {},
      }
    },
    methods: {
      open(record) {
        this.record = Object.assign({}, record)
        this.$refs.modal.open()
      },
      renameFile(e) {
        this.store.updateRecord(this.record, new FormData(e.target)).then(() => {
          this.store.sendMetrics({name: 'rename_file', params: this.$route.params, path: this.$route.fullPath})
          this.$emit('success')
          this.$refs.modal.close()
        })
      }
    }
  }
</script>
